import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { HubMode } from '@shared/models';
import { AuthenticationService } from '@shared/services/authentication.service';
import { CurrentHubService } from '@shared/services/currentHub.service';

export const SpaceHubMatchGuard: CanMatchFn = async (route: Route, segments: UrlSegment[]) => {
  const authService = inject(AuthenticationService);
  const hubService = inject(CurrentHubService);
  const router = inject(Router);
  if (segments.length === 0 || !segments[0]?.path) {
    return false;
  }

  const isAuth = await authService.isAuth();
  if (!isAuth) {
    return router.parseUrl('/login');
  }
  const hub = await hubService.getOrSetCurrentHub(segments[0]?.path);
  if (!hub) return router.parseUrl('/error?status=403');
  return hub?.mode === HubMode.space;
};
